import { api } from '@api/api2';
import type { SearchResidentsPayload } from './types';

export const searchResidents = (payload: SearchResidentsPayload) =>
  api.v4('get', 'residents-new/search', { ...payload, with_archived: 1 });
